export enum WaitingResponseType {
  None = 0,
  WaitingResponseFromCustomer = 1,
  Responded = 2,
  Cancelled = 3,
}
